module.exports = __webpack_public_path__ + "assets/img/Entrepreneurs_001.a3462849-ps.jpg";